import { useMediaQuery } from 'usehooks-ts'

export default function useIsMobile(query = '(max-width: 1024px)') {
  return useMediaQuery(query)
}

export function useIsSM(query = '(max-width: 640px)') {
  return useMediaQuery(query)
}
